import React from 'react';

import Icon, { faCircle } from '~components/icon';

interface ComponentProps {
  rowData: {
    colour: string;
  };
}

const ServiceColourBadge: React.FC<ComponentProps> = ({ rowData }) => {
  const colour = `#${rowData.colour}`;

  return (
    <div className="d-flex align-items-center">
      <Icon icon={faCircle} className="me-1" style={{ color: colour }} />
      <span>{colour}</span>
    </div>
  );
};

export default ServiceColourBadge;
